import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityClassicWorkEmbedRoute: InvariantJiraRoute = {
	name: 'software-capacity-classic-work-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/work/embed',
	query: [],
};
